import Insight from "../insightClass";
import React from "react";
import { insight102Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight102 = new Insight(
  "16 March 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight102Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly",
  "",
  `The UK government said it will remove tariffs on 33 industrial goods used in offshore wind manufacturing from 1 April 2026, arguing that the change should save manufacturers millions of pounds each year and reduce input costs across the supply chain. Trade and industry reporting indicates the measure is aimed at components and materials used in offshore wind manufacturing rather than end-market electricity support.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-03-16)</h1>
    <h2></h2>
    <p className="article-date">16 March 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>1. UK removes tariffs on offshore wind manufacturing inputs</h3>
    <p>
      The UK government said it will remove tariffs on 33 industrial goods used
      in offshore wind manufacturing from 1 April 2026, arguing that the change
      should save manufacturers millions of pounds each year and reduce input
      costs across the supply chain. Trade and industry reporting indicates the
      measure is aimed at components and materials used in offshore wind
      manufacturing rather than end-market electricity support.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is a practical cost-down measure rather than a headline-grabbing
      subsidy reform. Its importance lies in timing. As developers, OEMs and
      fabricators prepare for a new build cycle after the UK’s latest CfD round,
      even modest input-cost relief can improve tender economics, protect
      margins in fixed-price contracts and strengthen the business case for
      UK-based assembly and fabrication. The bigger strategic question is
      whether tariff relief will be followed by equally targeted action on
      ports, grid delivery, consenting and workforce capability. On its own,
      tariff removal helps; as part of a wider industrial package, it could
      become materially more valuable.
    </p>
    <h3>2. RWE and Vestas advance the UK’s Norfolk Vanguard build-out</h3>
    <p>
      RWE placed a firm turbine order with Vestas for the 1,380MW Vanguard East
      project in the UK, with 92 V236-15.0 MW units to be supplied, delivered
      and commissioned. This followed the earlier confirmation for Vanguard
      West, taking the two projects together to 2.76GW. RWE said it expects
      final investment decisions for both projects in summer 2026, with Vanguard
      West scheduled for commissioning in 2029 and Vanguard East in 2030.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This matters because it is moving from auction success into bankable
      execution. The UK market has recently needed evidence that awarded
      projects can translate into equipment orders, financing progress and
      credible delivery schedules. The Norfolk Vanguard package does exactly
      that. It also reinforces a broader industry trend: developers are
      concentrating procurement around large-volume turbine platforms and
      long-term supplier relationships to de-risk delivery. For the UK, this is
      one of the clearest signs this week that AR7 was not just a policy reset,
      but the start of a more investable pipeline.
    </p>
    <h3>
      3. Scotland’s 1GW Ayre floating wind project clears an onshore planning
      hurdle
    </h3>
    <p>
      Highland Council granted planning consent for the onshore infrastructure
      of Qair’s Ayre floating offshore wind farm in Scotland. The approved works
      include cable landfall, underground cable circuits, a new onshore
      substation and associated infrastructure in the Spittal area of Caithness.
      The offshore application seeks consent for up to 67 wind turbines with an
      installed capacity of about 1,008MW, and construction is anticipated to
      begin around 2030, subject to further consents.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      For floating wind, onshore progress is often the real gating factor. The
      sector still attracts attention for platform design and turbine scale, but
      project bankability depends just as much on landfall strategy, grid
      connection, transmission interfaces and local planning discipline. Ayre’s
      progress is therefore significant beyond its own 1GW scale. It shows that
      floating projects in northern Scotland are moving deeper into the
      real-world delivery phase, where transmission readiness and community
      interface become as important as engineering innovation. That is exactly
      the stage at which many floating pipelines globally start to slow down.
    </p>
    <h3>
      4. RWE completes sale of Poland’s 350MW F.E.W. Baltic II project to PGE
    </h3>
    <p>
      RWE completed the sale of the 350MW F.E.W. Baltic II development project
      to PGE, including the transfer of an environmental decision for the
      neighbouring 44.E.1 site. The project is located around 50km north of
      Ustka in the Polish Baltic Sea. Reporting from TGS 4C said RWE believes
      PGE is better placed to advance the project alongside its wider Polish
      offshore portfolio, while RWE reiterated that its broader offshore
      ambitions remain unchanged.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is a reminder that portfolio optimisation is now a core feature of
      offshore wind strategy, especially in emerging markets. As project
      pipelines deepen, asset ownership is increasingly being shaped by who has
      the strongest local route to grid, permitting, political alignment and
      long-term system integration. In Poland, local anchoring still matters
      enormously. For PGE, consolidation can improve strategic control in a
      fast-rising Baltic market. For RWE, the move reflects disciplined capital
      allocation rather than retreat. We expect more examples of this kind of
      portfolio reshaping across Europe as developers prioritise balance-sheet
      efficiency and execution certainty.
    </p>
    <h3>
      5. Belfast Harbour and Port of Cork sign a 10-year offshore wind
      partnership
    </h3>
    <p>
      Belfast Harbour and the Port of Cork signed a 10-year memorandum of
      understanding designed to accelerate offshore renewable energy delivery,
      alongside wider cooperation on trade, tourism, innovation and resilience.
      The agreement was welcomed by ministers in Ireland and supported by both
      the Irish government and the Northern Ireland Executive. Official
      statements say the partnership is intended to support all-island economic
      growth and help develop port infrastructure relevant to offshore renewable
      energy.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Port strategy is becoming one of the decisive competitive layers in
      offshore wind. This agreement is important not because it instantly
      creates capacity, but because it aligns two strategically placed ports
      around a shared infrastructure narrative. In the next phase of offshore
      wind growth, regional port systems will matter more than stand-alone
      sites: marshaling, assembly, O&M, heavy logistics and supply-chain
      clustering increasingly need networked capability. The Belfast–Cork link
      is therefore best read as an early institutional response to that reality.
      The value will depend on whether the MoU converts into funded upgrades,
      coordinated investment plans and tangible project capture.
    </p>
    <h3>6. Global offshore wind capacity is closing in on the 100GW mark</h3>
    <p>
      Industry reporting this week said global fully operational offshore wind
      capacity rose by 6.7GW over the last 12 months to 89.2GW, and could pass
      the 100GW threshold in 2026. The same reporting said 18.8GW could be
      delivered this year as projects complete in China, the UK, Germany, the
      US, Taiwan and Poland. RenewableUK’s earlier EnergyPulse commentary also
      pointed to 18.8GW of global offshore wind capacity potentially reaching
      full operation in 2026.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The symbolic importance of 100GW should not be underestimated. It marks
      offshore wind’s transition from a specialist growth market into a truly
      large-scale global power asset class. But the more important signal is
      geographical breadth. The expected 2026 additions are not concentrated in
      a single country; they are spread across Europe, Asia and North America.
      That diversification is strategically healthy. It reduces dependence on
      one policy regime, broadens the supplier base and gives the industry a
      better chance of sustaining volume through political cycles. The challenge
      is that headline growth can still mask weak economics in parts of the
      chain, so scale alone should not be confused with sector-wide health.
    </p>
    <h3>
      7. Maersk formally names its first next-generation installation vessel,
      Maersk Viridis
    </h3>
    <p>
      Maersk Offshore Wind formally named Maersk Viridis, its first
      next-generation wind turbine installation vessel, after delivery from
      Seatrium in late February. Industry reporting says the vessel is designed
      for 15+MW turbines, has a 1,900-tonne crane with 180-metre hook height,
      and is expected to begin work on the Empire Wind project off New York. The
      vessel uses a feeder-based installation concept intended to support
      efficient installation under US operating constraints.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Specialised vessel capacity remains one of the most underappreciated
      constraints in offshore wind delivery. Maersk Viridis is not just another
      ship entering the market; it represents the kind of high-spec installation
      asset required for the 15MW-plus era. That matters globally because
      turbine scaling is outpacing parts of the marine logistics chain. It also
      matters in the US, where project execution depends heavily on installation
      models that can navigate regulatory and vessel-availability constraints.
      In other words, this is supply-chain news, but it is also project-finance
      news: without dependable installation capability, schedules slip, costs
      rise and risk premia widen.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
